import React, { useState } from 'react';
import { goToBudgetCategoryTransactions } from 'src/services/router.service';
import CategoryHistoryModal from 'src/components/atomic/organisms/transaction/category-history-modal/CategoryHistoryModal';
import styles from './categoryCard.module.scss';
import { SpendingSumModel } from 'src/types/spending-sum.model';
import { BudgetModel } from 'src/types/budget.model';
import * as H from 'history';
import CategoryCardFooter from 'src/components/atomic/organisms/categoryCardFooter/CategoryCardFooter';
import CategoryCardBody from 'src/components/atomic/organisms/categoryCardBody/CategoryCardBody';
import { CategoryModel } from 'src/types/category.model';
import adobeTags from 'src/types/adobe-tags';
import { getCategoryTagName } from 'src/utils/category.utils';
import Selectors from 'src/utils/selectors';
import { BudgetPages } from '../../pages/BudgetPages';

interface CategoryCardProps {
    spending: SpendingSumModel;
    budget?: BudgetModel;
    categories: CategoryModel[];
    hasSubcategories?: boolean;
    showingSubcategories?: boolean;
    handleShowSubcategories?: () => void;
    parentName?: string;
    history: H.History;
    isMinWidthSmall?: boolean;
}

export default function CategoryCard({
    spending,
    budget,
    hasSubcategories,
    showingSubcategories,
    handleShowSubcategories,
    parentName,
    categories,
    history,
    isMinWidthSmall
}: CategoryCardProps): JSX.Element {
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const isSubcategory = !!parentName;
    const categoryGroupId = spending.groupId;
    const category: CategoryModel = categories.find((category) => category.id === spending.groupId);
    const fullTagName: string =
        adobeTags.CategoryBreakdown.CategorySelect + '>' + getCategoryTagName(category, categories);
    const isHomePage = history.location.pathname === BudgetPages.HOME;
    const cardStyle = isSubcategory
        ? styles.categoryCardChild
        : hasSubcategories && budget && isMinWidthSmall
        ? styles.categoryCardParent
        : styles.categoryCardParentExtraSpace;

    const handleOnClickLink = (): void => {
        if (isHomePage) goToBudgetCategoryTransactions(false, history, categoryGroupId);
        else setModalOpen(true);
    };

    return (
        <div className={cardStyle} data-cy={Selectors.SpendSmart.CATEGORY_CARD}>
            <CategoryCardBody
                spending={spending}
                budget={budget}
                fullTagName={fullTagName}
                isMinWidthSmall={isMinWidthSmall}
                parentName={parentName}
                isHomePage={isHomePage}
                handleOnClick={handleOnClickLink}
            />
            <CategoryCardFooter
                budgetAmount={budget?.monthlyAmount}
                spentAmount={spending.spent}
                groupId={spending.groupId}
                isMinWidthSmall={isMinWidthSmall}
                hasSubcategories={hasSubcategories}
                showingSubcategories={showingSubcategories}
                handleShowSubcategories={handleShowSubcategories}
            />
            {modalOpen && <CategoryHistoryModal groupId={spending.groupId} closeModal={() => setModalOpen(false)} />}
        </div>
    );
}
